.step {
	display: flex;
	align-items: center;
	gap: var(--content-padding-small);
	padding: var(--content-padding-small);
	background-color: var(--color-surface-muted);
	border: 1px solid var(--dropdown-border);
	border-radius: var(--border-radius-base);

	&.stepPrimary {
		background-color: var(--alert-primary-bg);
		border-color: var(--alert-primary-border);
	}

	&.thresholdStep {
		margin-top: var(--content-padding-small);
	}

	&.warning {
		background-color: var(--alert-warning-bg);
		border-color: var(--alert-warning-border);
	}

	.text {
		flex: 1;
	}

	/* A fixed share instead of auto, so the controls of both steps line up regardless of label length per language. */
	.control {
		flex: 0 0 25%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--content-padding-small);
	}

	/* Fits the input's five-digit maxLength plus the form-control padding. */
	.thresholdInput {
		width: 6em;
	}
}
